<template>
    <k-panel class="border">
        <k-panel-header slot="header">{{ $t("autoInvestmentFaq") }}</k-panel-header>
        <div>
            <a-collapse :bordered="false" expand-icon-position="right">
                <a-collapse-panel :key="item.question" :header="item.question" class="no-bottom-border"
                                  v-for="(item) in faqItems">
                    <p>{{item.answer}}</p>
                </a-collapse-panel>
            </a-collapse>
        </div>
    </k-panel>
</template>

<script>
    export default {
        components: {},
        props: {
            faqItems: {
                type: Array,
                default: () => {
                    return [
                        {
                            question: 'What is Auto-Invest?',
                            answer: 'Auto-Invest is an advanced tool that helps investors to save time and ensure better diversification by purchasing multiple debenture tranches accordingly to a pre-determined set of criteria. Investors can create an investment portfolio profile beforehand by selecting the desirable terms, interest rates, loan originators and countries so that the system can make future purchases based on those criteria.'
                        },
                        {
                            question: 'How does Auto-Invest work?',
                            answer: 'First, you must activate your Auto-Invest portfolio and allocate funds to this portfolio. The system will automatically filter among all the debentures listed at the platform and purchase those that meet your investment criteria. Every time a new debenture is issued, the system will evaluate if it is eligible to purchase based on your defined criteria. This feature is programmed to make the best of the allocated funds to make them work most of the time. In case there are not enough debentures at the platform meeting the specified criteria, the funds will remain allocated in your account.'
                        },
                        {
                            question: 'How to create my Auto-Invest portfolio?',
                            answer: 'It is simple, just go to the Auto-Invest section to determine the portfolio size, diversification weight and the criteria such as terms, interest rates, loan originators and countries to be considered by the system when purchasing a debenture.'
                        },
                        {
                            question: 'Can I stop Auto-Invest?',
                            answer: 'You can immediately edit, deactivate and delete portfolios at any time by visiting the Auto-Invest settings. The already purchase debentures will remain at your account until their maturity.'
                        },
                        {
                            question: 'Can I use Auto-Invest and invest manually?',
                            answer: 'Yes, you can still invest your funds manually while using the Auto-Invest tool as long as you have enough available funds.'
                        },
                        {
                            question: 'Are there any extra costs to use Auto-Invest?',
                            answer: 'No, this is a free convenient tool provided by the platform to promote diversification and save time for the investors.'
                        },
                    ];
                }
            }
        },
        data() {
            return {};
        }
    };
</script>

<style scoped>
    .no-bottom-border {
        border-bottom: 0;
    }
</style>


